import axios from '../utils/axiosInstance';

export const getEvaAgentsAPI = async () => {
  const response = await axios.get('ReportConfiguration/');
  return response;
};
